export default function onThrottled(element: JQuery<any>, eventName: string, callback: Function, threshold?: number) {
  let timeout: NodeJS.Timeout;
  element.on(eventName, function (e) {
    clearTimeout(timeout);
    timeout = setTimeout(function () {
      callback(e);
    }, threshold || 100);
  });
}
